export default __webpack_public_path__ + "static/media/devin.352db9f9.jpg";